import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Formik, FormikProps } from "formik";
import debounce from "lodash/debounce";
import LabeledSelectInput from "../../../ui-components/molecules/labeled-inputs/labeled-select-input/labeledSelectInput";
import XGSFormDate from "../../../ui-components/form/date/xgsFormDate";
import { LabelModes } from "../../../ui-components/molecules/labeled-inputs/labeledInput";
import Button, { ButtonThemes } from "../../../ui-components/button/button";
import {
  PickupLocationModel,
  PickupLocationSchema
} from "../../../app/data/rates/models";
import { StepProps } from "../../../app/data/common/models";
import RequestRatesState from "../../../slices/rates/RequestRatesState";
import {
  clearShippingItems,
  requestRatesSelector,
  setPickupLocation,
  searchLocations
} from "../../../slices/rates/requestRatesSlice";
import { getFreightClasses, getServiceCenterDays, getXgsHolidays } from "../../../slices/common/commonSlice";
import CommonState from "../../../slices/common/CommonState";
import {
  commonSelector,
} from "../../../slices/common/commonSlice";
import { firstServiceCenterWorkDay } from "../../../services/common/date";

const initialValues: PickupLocationModel = {
  location: null,
  date: ""
};

const PickupLocation: React.FC<StepProps> = (props) => {
  const dispatch = useDispatch();
  const { next } = props;
  const requestRatesState: RequestRatesState = useSelector(requestRatesSelector);
  const commonState: CommonState = useSelector(commonSelector);
  const [locationFormValue, setLocationFormValue] = useState<{ value: string, label: string, subtitle?: string } | null>();

  const onSubmit = (data: PickupLocationModel) => {
    dispatch(setPickupLocation(data));
    if (data.location) {
      dispatch(getFreightClasses(data.location.value));
    }
    next && next();
  };

  let locationSearch = (e: string) => {
    e?.length > 1 && dispatch(searchLocations("PICKUP", e));
  }
  locationSearch = debounce(locationSearch, 300);

  const getHolidayDates = () => commonState.xgsHolidays.map((holiday) => holiday.date);

  useEffect(() => {
    initialValues.location = requestRatesState.pickupLocation;
    initialValues.date = requestRatesState.pickupDate;
    requestRatesState.pickupLocation && setLocationFormValue({
      label: requestRatesState.pickupLocation.label,
      value: requestRatesState.pickupLocation.value
    });
  }, [requestRatesState.pickupLocation, requestRatesState.pickupDate]);

  return (
    <div className="xgs-request-rates__pickup-location">
      <div className="xgs-request-rates__step__header">Pickup Location</div>
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={PickupLocationSchema}
        enableReinitialize
      >
        {(props: FormikProps<PickupLocationModel>) => (
          <Form className="form-items">
            <LabeledSelectInput
              className="xgs-request-rates__location-field"
              isDisabled={false}
              isLoading={requestRatesState.requestStarted}
              label="Pickup Location:"
              labelMode={LabelModes.column}
              name="location"
              onInputChange={locationSearch}
              onValueChange={(v) => {
                props.setFieldValue("location", {
                  label: v?.label,
                  value: v?.value
                });
                setLocationFormValue(v);
                if (locationFormValue?.value !== v?.value) {
                  dispatch(clearShippingItems());
                }
                if (v?.value && /^\d{5}$/.test(v.value)) {
                  dispatch(getServiceCenterDays(v.value));
                  dispatch(getXgsHolidays());
                }
                props.setFieldValue("date", "")
              }}
              openMenuOnClick={requestRatesState.pickupLocations.length > 0}
              options={requestRatesState.pickupLocations}
              placeholder="Enter Zip or City..."
              value={locationFormValue}
            />            
            <XGSFormDate
              name="date"
              label="Tender Date:"
              onDateChange={(v) => {
                props.setFieldValue("date", v);
              }}
              onChange={() => null}
              minDate={new Date(firstServiceCenterWorkDay(commonState.pickupDays, getHolidayDates(), true))}
              required={true}
              requiredAsteriskDisabled={true}
              labelMode={LabelModes.column}
              className="xgs-request-rates__pickup-location__date-field"
              disableWeekends={true}
              disabledWeekDays={commonState.pickupDays}
              disabledDates={getHolidayDates()}
              disabled={!locationFormValue}
            />
            <Button
              type="submit"
              theme={ButtonThemes.blue}
              style={{ marginTop: 38 }}
              disabled={!props.isValid || !props.values.location}
              className="xgs-request-rates__step__nav-button"
            >
              Next
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PickupLocation;
